
import { Timestamp } from '@angular/fire/firestore';
import { CrudModel } from '@core/crud/crud-model.interface';
import { AddressData } from 'zafirus-pick-location';

export interface SignupConsorcistaToken extends CrudModel {
    createdAt: Timestamp | Date,
    uid: string,
    consorcioId: string,
    cod: string,
    administrationId: string,
    wspId: string,
    firstName?: string,
    lastName?: string,
    
}
export const MODELNAME = 'signupConsorcistaTokens'
export type model = SignupConsorcistaToken;
